<script setup lang="ts">
import dayjs from 'dayjs'

import type { ChipColor } from '@/components/base/BaseChip.vue'
import type { ContestGame } from '@/views/contests/ContestsPage.vue'

const props = defineProps<{
  contest: ContestGame
}>()
const { t } = useI18n()

const contestTag: {
  text: {
    active: string
    terminated: string
    paused: string
    programmed: string
  }
  color: {
    active: ChipColor
    terminated: ChipColor
    paused: ChipColor
    programmed: ChipColor
  }
} = {
  text: {
    active: t('pages.contests.contestsPage.table.tbody.active'),
    terminated: t('pages.contests.contestsPage.table.tbody.terminated'),
    paused: t('pages.contests.contestsPage.table.tbody.paused'),
    programmed: t('pages.contests.contestsPage.table.tbody.programmed')
  },
  color: {
    active: 'green',
    terminated: 'red',
    programmed: 'yellow',
    paused: 'orange'
  }
}

const getContestStatus = (contest) => {
  const now = dayjs()
  const startDate = dayjs(contest.fromDate)

  if (contest.isActive) {
    return 'active'
  }
  if (contest.isPaused) {
    return 'paused'
  }
  if (startDate.isAfter(now)) {
    return 'programmed'
  }

  return 'terminated'
}
const contestStatus = computed(() => getContestStatus(props.contest))
</script>

<template>
  <BaseChip :text="contestTag.text[contestStatus]" :color="contestTag.color[contestStatus]" />
</template>
